import { render } from "./CodeViewer.vue?vue&type=template&id=0ec06bae&scoped=true"
import script from "./CodeViewer.vue?vue&type=script&lang=js"
export * from "./CodeViewer.vue?vue&type=script&lang=js"

import "./CodeViewer.vue?vue&type=style&index=0&id=0ec06bae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ec06bae"

export default script